import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
// import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { Icon, DateField } from '@jutro/components';
import { InputField } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import metadata from './FormPredecesFirmComponent.metadata.json5';

function FormPredecesFirmComponen(props) {

    const {
        data: FormerPredecessorFirmsVM,
        updateWizardData,
        submissionVM,
        ForPredFirmPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    
    FormerPredecessorFirmsVM.value.isValidationReq = true

    const addForPredFirm = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            FormerPredecessorFirmsVM.value = FormerPredecessorFirmsVM.value || []

            const { _xCenter, _dtoName } = FormerPredecessorFirmsVM;

            const FormerPredecessorFirmsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            FormerPredecessorFirmsVM.pushElement(
                FormerPredecessorFirmsObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, FormerPredecessorFirmsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            FormerPredecessorFirmsVM.value.splice(index, 1);
            _.set(submissionVM.value, ForPredFirmPath, FormerPredecessorFirmsVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, ForPredFirmPath, FormerPredecessorFirmsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'nam1') {
                const value = item.nam1 ? item.nam1 : '';

                return (
                    <InputField
                        id={index + path}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.nam1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if(path === 'datEst2') {
                const value = item.datEst2 ? item.datEst2 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.datEst2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if(path === 'datCeaToOpe3') {
                const value = item.datCeaToOpe3 ? item.datCeaToOpe3 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            // eslint-disable-next-line no-param-reassign
                            item.datCeaToOpe3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }
        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                // className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" /* className={styles.deleteIcon} */ />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`ForPredFirmTable`]: {
            data: FormerPredecessorFirmsVM.value,
        }

    }), [FormerPredecessorFirmsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addForPredFirm,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            FormerPredecessorFirmsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [FormerPredecessorFirmsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={FormerPredecessorFirmsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

FormPredecesFirmComponen.propTypes = wizardProps;
export default withRouter(FormPredecesFirmComponen);
